// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1ZnKW","info":"UpdateTermsInfo_info__3RPyB"};